import {
	dropSectionImports,
	type DropSectionKey,
} from '../../constants/dropSectionImports/dropSectionImports';
import type { DropSections } from '../../constants/dropSectionImports/types';
import { getDropSectionKey } from '../getDropSectionKey/getDropSectionKey';

const isDropSectionKey = (key: string | null): key is DropSectionKey =>
	!!key && Object.hasOwn(dropSectionImports, key);

// Imports the components of the sections a drop page holds, and only those,
// for the drop routes' universal loads. SvelteKit awaits those loads before it
// hydrates or renders a client-side navigation, so `DropPageGenerator` has
// every component it needs on its first render: no flash, no layout shift.
// Items of a type the generator does not render are ignored, as it ignores
// them.
export const loadDropSections = async (
	items:
		| readonly ({ __typename?: string; name?: string | null } | null)[]
		| null
		| undefined
): Promise<DropSections> => {
	const keys = new Set(
		(items ?? []).map(getDropSectionKey).filter(isDropSectionKey)
	);

	const sections = await Promise.all(
		[...keys].map((key) => dropSectionImports[key]())
	);

	return Object.assign({}, ...sections);
};
